import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";
import UploadSKBloc from "./Blocs/UploadSKBloc";

var reformatSignatory = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] =
      region.signatories_official_nip +
      " - " +
      region.signatories_official_name;
    newObj["value"] = region.signatories_official_uuid;
    newObj["nip_pejabat"] = region.signatories_official_nip;
    newObj["nama_pejabat"] = region.signatories_official_name;
    return newObj;
  });
};

class IndexView extends Component {
  uploadSKBloc = new UploadSKBloc();

  queryParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        nip_pejabat: "",
        nama_pejabat: "",
      },
      birthNational: "",
      sigantoryItems: [],
      sigantorySelected: "",
    };
  }

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseYMD = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("YYYY-MM-DD");
    }
    return res;
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  onChangeSignatory = (signatory) => {
    this.setState((prevState) => ({
      sigantorySelected: signatory.value,
      dataForm: {
        ...prevState.dataForm,
        nip_pejabat: signatory.nip_pejabat,
        nama_pejabat: signatory.nama_pejabat,
      },
    }));
  };

  errorField = (message) => {
    this.setState({
      loading: false,
      failed: true,
      failedInfo: message,
    });
  };

  downloadDraftSPMT = () => {
    var no_sk = document.getElementsByName("cp3k_decree_number")[0].value;
    var no_spmt = document.getElementsByName("cp3k_spmt_number")[0].value;
    var tgl_sk = document.getElementsByName("cp3k_decree_date")[0].value;
    var tmt_sk = document.getElementsByName("cp3k_decree_tmt_date")[0].value;

    if (no_sk == "") {
      this.errorField("No Surat Keputusan Kosong!");
      return 0; // berhenti
    }
    if (no_spmt == "") {
      this.errorField("No Surat Pernyataan Melaksanakan Tugas Kosong!");
      return 0; // berhenti
    }
    if (tgl_sk == "") {
      this.errorField("Tanggal Surat Keputusan Kosong!");
      return 0; // berhenti
    }
    if (tmt_sk == "") {
      this.errorField("Terhitung Mulai Tanggal! Kosong!");
      return 0; // berhenti
    }

    this.uploadSKBloc.fetchDownloadSPMT({
      cp3k_uuid: this.queryParams.get("uuid"),
      signatory_uuid: this.state.sigantorySelected,
      no_sk: no_sk,
      no_spmt: no_spmt,
      tgl_sk: tgl_sk,
      tmt_sk: tmt_sk,
    });
  };

  downloadDraftPlanLetter = () => {
    this.uploadSKBloc.fetchDownloadPlanLetter();
  };

  submitData = async () => {
    let files = [
      "file_sk",
      "file_plan_letter",
      // "file_contract",
      // "file_kk",
      // "file_akta_anak",
      // "file_akta_nikah",
      // "file_bank",
      // "file_npwp",
    ];
    const formData = generateFormData(this.state.dataForm, files); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.uploadSKBloc.fetchUploadSk(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        uuid: this.state.dataForm.cp3k_uuid,
      },
      confirm: true,
    });
  };

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != "") {
      res = parseFloat(num).toLocaleString("id-ID", {
        maximumFractionDigits: 2,
      });
    }
    return res;
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.uploadSKBloc.uploadSkChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: "Data gagal disimpan",
          });
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // load to form
            this.setState({
              dataForm: response,
              birthNational: response.cp3k_candidate_place_of_birth_national,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.signatoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              sigantoryItems: reformatSignatory(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.downloadSPMTChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.downloadPlanLetterChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.fetchDetail({ uuid: this.queryParams.get("uuid") });

    this.uploadSKBloc.fetchSignatory();
  }

  componentWillUnmount() {
    this.uploadSKBloc.uploadSkChannel.unsubscribe();
    this.uploadSKBloc.detailChannel.unsubscribe();
    this.uploadSKBloc.signatoryChannel.unsubscribe();
    this.uploadSKBloc.downloadSPMTChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Verifikasi & Upload SK Calon PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Penetapan NIP BKN
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_number"
                          placeholder="Nomor"
                          errorMessage="Masukkan Nomor"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_bkn_confirmation_number
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_date"
                          placeholder="Tanggal"
                          errorMessage="Masukkan Tanggal"
                          type="date"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_bkn_confirmation_date
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Lengkap
                      </Label>
                      <Col md="4">
                        <AvField
                          name="cp3k_candidate_name"
                          placeholder="Nama"
                          errorMessage="Masukkan Nama"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_full_name}
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Email BKPM
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_email"
                          placeholder="Email BKPM"
                          errorMessage="Masukkan Email BKPM"
                          type="email"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_email}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor HP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_phone_number"
                          placeholder="Nomor HP"
                          errorMessage="Masukkan Nomor HPP"
                          type="number"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_phone_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIK</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_nik"
                          placeholder="NIK"
                          errorMessage="Masukkan NIK"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_nik}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor KK
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_familiy_card_number"
                          placeholder="Nomor KK"
                          errorMessage="Masukkan Nomor KK"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_familiy_card_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor NPWP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_npwp_number"
                          placeholder="Nomor NPWP"
                          errorMessage="Masukkan Nomor NPWP"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_npwp_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIP</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_nip"
                          placeholder="NIP"
                          errorMessage="Masukkan NIP"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_nip}
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tempat Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          type="text"
                          className="form-control"
                          value={this.state.birthNational}
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_country_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_country_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? {}
                          : { display: "none" }
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_province_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_province_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_city_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_city_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? { display: "none" }
                          : {}
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_city_text
                          }
                          // validate={{
                          //   required: {
                          //     value:
                          //       this.state.birthNational == "Dalam Negeri"
                          //         ? false
                          //         : true,
                          //   },
                          // }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Kode Pos
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_postal_code"
                          placeholder="Kode Pos"
                          errorMessage="Masukkan Kode Pos"
                          type="number"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_postal_code
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Alamat</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_address"
                          placeholder="Alamat"
                          errorMessage="Masukkan Alamat"
                          type="textarea"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_address}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tanggal Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_date_of_birth"
                          placeholder="Tanggal Lahir"
                          errorMessage="Masukkan Tanggal Lahir"
                          type="date"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_date_of_birth
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Jenis Kelamin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_gender_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_gender_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Status Kawin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_marital_status_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_marital_status_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Pendidikan Terakhir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_last_education_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_major"
                          placeholder="Program Studi / Jurusan"
                          errorMessage="Masukkan Program Studi"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_last_education_major
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Jabatan</Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_position_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_position_name
                          }
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Golongan
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_rank_name"
                          type="text"
                          className="form-control"
                          value={`${this.state.dataForm?.cp3k_candidate_rank_name}`}
                          // validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja
                      </Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_work_unit_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_work_unit_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Bank</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_account_bank_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_number"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_account_bank_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_account_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Agama</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_religion_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_religion_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pejabat Penetap <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <Select
                          value={this.state.sigantoryItems.filter(
                            (option) =>
                              option.value === this.state.sigantorySelected
                          )}
                          onChange={this.onChangeSignatory}
                          required="required"
                          placeholder="Pilih Pejabat Penetap"
                          options={this.state.sigantoryItems}
                          classNamePrefix=""
                        />
                        <AvField
                          name="sigantory_id"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="sigantory_id"
                          value={this.state.sigantorySelected}
                          errorMessage="Pilih Pejabat Penetap"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pejabat Penetap{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="nama_pejabat"
                          id="nama_pejabat"
                          placeholder="Nama Pejabatan Penetap"
                          type="text"
                          className="form-control"
                          readOnly
                          value={this.state.dataForm.nama_pejabat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP Pejabat Penetap{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="nip_pejabat"
                          id="nip_pejabat"
                          placeholder="NIP Pejabatan Penetap"
                          type="text"
                          className="form-control"
                          readOnly
                          value={this.state.dataForm.nip_pejabat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK Calon PPPK{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="cp3k_decree_number"
                          id="cp3k_decree_number"
                          placeholder="Nomor SK Calon PPPK"
                          type="text"
                          errorMessage="Masukan Nomor SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm?.cp3k_decree_number}
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SPMT <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="cp3k_spmt_number"
                          id="cp3k_spmt_number"
                          placeholder="Nomor SPMT"
                          type="text"
                          errorMessage="Masukan Nomor SPMT"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm?.cp3k_spmt_number}
                        />
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal SK Calon PPPK{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="cp3k_decree_date"
                          id="cp3k_decree_date"
                          placeholder="Tanggal SK Calon PPPK"
                          type="date"
                          errorMessage="Masukan Tanggal SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.dateParseYMD(
                            this.state.dataForm?.cp3k_decree_date
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT SK Calon PPPK <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="cp3k_decree_tmt_date"
                          id="cp3k_decree_tmt_date"
                          placeholder="TMT SK Calon PPPK"
                          type="date"
                          errorMessage="Masukan TMT SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.dateParseYMD(
                            this.state.dataForm?.cp3k_decree_tmt_date
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File SK Calon PPPK{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_sk"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File SK Calon PPPK"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Surat Pernyataan Rencana Penempatan{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_plan_letter"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih  Surat Pernyataan Rencana Kerja"
                        />
                      </Col>
                      <Col md="3">
                        <a
                          target={"_blank"}
                          className="btn btn-sm btn-success"
                          onClick={this.downloadDraftPlanLetter}
                          // href={this.state.document_spmt?.documents_path}
                        >
                          Download Draft <i className="fa fa-download ms-1"></i>
                        </a>
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Kontrak Kerja{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_contract"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Kontrak Kerja"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Kartu Keluarga{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_kk"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Kartu Keluarga"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Akta Lahir Anak{" "}
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_akta_anak"
                          accept=".pdf"
                          col="2"
                          errorMessage="Pilih File Akta Lahir Anak"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Akta Nikah{" "}
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_akta_nikah"
                          accept=".pdf"
                          col="2"
                          errorMessage="Pilih File Akta Nikah"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Buku Tabungan{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_bank"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Buku Tabungan"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File NPWP <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_npwp"
                          accept=".pdf"
                          col="2"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File NPWP"
                        />
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link
                          to={`/kepegawaian/cp3k.html?create_cp3k&uuid=${this.queryParams.get(
                            "period_uuid"
                          )}`}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          // failedInfo="Data gagal disimpan"
          failedInfo={this.state.failedInfo}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={`/kepegawaian/cp3k.html?create_cp3k&uuid=${this.queryParams.get(
              "period_uuid"
            )}`}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
